import styled from "styled-components";

export const RootContainer = styled.div`
	position: relative;

	.ant-table-wrapper {
		margin: 82px 16px 24px 16px;
	}
`;

export const Top = styled.div`
	/* position: relative; */
	text-align: center;
	/* z-index: 1; */
	/* padding-top: 50px; */
	margin: 20px 0 20px;
`;

export const LightText = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${(props) => props.theme.dark1};
`;

export const Text = styled.div`
	font-size: 18px;
	font-weight: 600;
	color: ${(props) => props.theme.textColor};
`;

export const Table = styled.div`
	display: table;
	width: 93%;
	margin: 90px 16px 0px 16px;
	table-layout: fixed;
	max-height: 100px;
`;

export const TableHeading = styled.div`
	display: table-row;
	position: sticky;
	top: 0;
	background-color: #71207c;
	z-index: 1;

	> div:first-child {
		width: 60px;
	}

	@media screen and (max-width: 330px) {
		> div:first-child {
			width: 20px;
		}
	}
`;

export const TableRow = styled.div`
	display: table-row;
	background-color: #f1f1f1;
	:nth-of-type(odd) {
		background-color: #e1cce0;
	}
`;

export const TableHeadingCell = styled.div`
	display: table-cell;
	padding: 13px 5px;
	text-align: center;
	color: #fff;
	font-size: 14px;
	:first-child {
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
	}
	:last-child {
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
	}
	@media screen and (max-width: 365px) {
		font-size: 12px;
	}
	@media screen and (max-width: 330px) {
		padding: 8px 1px;
	}
`;

export const TableCell = styled.div`
	display: table-cell;
	padding: 13px 5px;
	text-align: center;
	color: #000;
	font-size: 14px;
	:first-child {
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
	}
	:last-child {
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
	}
	@media screen and (max-width: 365px) {
		font-size: 12px;
	}
	@media screen and (max-width: 330px) {
		padding: 8px 1px;
	}
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
`;

export const OuterDiv = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 15px 30px;
	background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const IndexNumber = styled.div`
	display: flex;
	gap: 5px;
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;
`;

export const InfoText = styled.span`
	color: ${(props) => props.date === true ? props.theme.dark2 : props.theme.textColor};
	font-size: 14px;
	line-height: 24px;
	font-weight: 400;
`;
